export type PromoCode = {
  code: string;
  type: "percent" | "fixed";
  value: number;
  description: string;
  minPrice: number;
};

export const promoCodes: PromoCode[] = [
  { code: "LAUNCH50", type: "percent", value: 50, description: "50% off - Launch Special", minPrice: 0 },
  { code: "CPI20", type: "percent", value: 20, description: "20% off - CPI Community", minPrice: 0 },
  { code: "SAVE100", type: "fixed", value: 100, description: "$100 off any course", minPrice: 200 },
  { code: "FIRSTCLASS", type: "percent", value: 30, description: "30% off - First-time student", minPrice: 0 },
  { code: "TEAM15", type: "percent", value: 15, description: "15% off - Team enrollment", minPrice: 0 },
  { code: "CHICAGO25", type: "percent", value: 25, description: "25% off - Chicago locals", minPrice: 0 },
];

export function applyPromo(code: string, price: number): { valid: boolean; discount: number; description: string; finalPrice: number } {
  const promo = promoCodes.find((p) => p.code === code.toUpperCase().trim());
  if (!promo) return { valid: false, discount: 0, description: "", finalPrice: price };
  if (price < promo.minPrice) return { valid: false, discount: 0, description: "", finalPrice: price };
  const discount = promo.type === "percent" ? Math.round((price * promo.value) / 100) : Math.min(promo.value, price);
  return { valid: true, discount, description: promo.description, finalPrice: price - discount };
}
